import { gql } from 'graphql-request';
import GraphQL from '@app/model/_common/service/GraphQL';
import { PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT } from '@app/model/process-request/service/ProcessRequestGraphQLFragments';

export const FIND_LATEST_ACTIVE_PROCESS_REQUEST_EXECUTION_STATE_QUERY: GraphQL = {
	name: 'findLatestActiveProcessRequestExecutionState',
	gql: gql`
		${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
		query findLatestActiveProcessRequestExecutionState {
			findLatestActiveProcessRequestExecutionState {
				...ProcessRequestExecutionStateFields
			}
		}
	`
};

export const FIND_PROCESS_REQUEST_EXECUTION_STATE_QUERY: GraphQL = {
	name: 'findProcessRequestExecutionState',
	gql: gql`
		${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
		query findProcessRequestExecutionState($requestId: Long!) {
			findProcessRequestExecutionState(requestId: $requestId) {
				...ProcessRequestExecutionStateFields
			}
		}
	`
};
